var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteBin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16.199,
    height: 17.913,
    viewBox: "0 0 16.199 17.913",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_150",
    "data-name": "Rectangle 150",
    width: 16.199,
    height: 17.913,
    fill: "#7e7e7e"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_82",
    "data-name": "Group 82",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_81",
    "data-name": "Group 81",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M24.153,45a.756.756,0,0,0,.753-.753v-4.9a.753.753,0,1,0-1.507,0v4.9a.756.756,0,0,0,.753.753",
    transform: "translate(-18.992 -31.329)",
    fill: "#7e7e7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M39.753,45a.756.756,0,0,0,.753-.753v-4.9a.753.753,0,1,0-1.507,0v4.9a.756.756,0,0,0,.753.753",
    transform: "translate(-31.654 -31.329)",
    fill: "#7e7e7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M55.353,45a.756.756,0,0,0,.753-.753v-4.9a.753.753,0,1,0-1.507,0v4.9a.756.756,0,0,0,.753.753",
    transform: "translate(-44.315 -31.329)",
    fill: "#7e7e7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M15.446,2.957h-3.8L11.17,1.375A1.939,1.939,0,0,0,9.324,0H6.875A1.939,1.939,0,0,0,5.029,1.375L4.558,2.957H.753a.753.753,0,0,0,0,1.507h.584V16.086a1.829,1.829,0,0,0,1.827,1.827h9.889a1.829,1.829,0,0,0,1.827-1.827V4.445h.565a.756.756,0,0,0,.753-.753.74.74,0,0,0-.753-.735M6.48,1.808a.424.424,0,0,1,.4-.3H9.343a.4.4,0,0,1,.4.3l.339,1.149H6.122Zm6.875,14.259a.33.33,0,0,1-.32.32H3.164a.33.33,0,0,1-.32-.32V4.445H13.374V16.067Z",
    transform: "translate(0 0)",
    fill: "#7e7e7e"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteBin);
export default __webpack_public_path__ + "static/media/delete-bin.8e18f60f8c27ad212f38dfffcb5b414b.svg";
export { ForwardRef as ReactComponent };